import React, { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export interface Props extends ReactDatePickerProps {
  classNames?: string;
}

const DatePicker = (ReactDatePicker as unknown as { default: typeof ReactDatePicker }).default ?? ReactDatePicker;

const TimePickerInput = forwardRef<
  HTMLButtonElement,
  DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement> & { placeholder?: string },
    HTMLButtonElement
  >
>(({ placeholder, value, ...rest }, ref) => <button ref={ref} type='button' {...rest}>{value || placeholder}</button>);

TimePickerInput.displayName = 'TimePickerInput';

const timeIntervalMinutesDefault = 15;
const timePickerClasses = 'flex p-2 w-28 h-10 ml-[5px] border-[1px] border-gray-400 outline-none rounded-md focus:border-sapphire focus:outline-none focus:ring-0 focus:ring-offset-0';

export const TimePicker = (props: Props): JSX.Element => {
  const { classNames, timeIntervals = timeIntervalMinutesDefault, ...rest } = props;

  return (
    <DatePicker
      {...rest}
      className={`${timePickerClasses}${classNames ? ` ${classNames}` : ''}`}
      customInput={<TimePickerInput />}
      popperClassName='z-50'
      showTimeSelectOnly
      showTimeSelect
      timeIntervals={timeIntervals}
    />
  );
};
